// Formatting shared by the Analytics pages. Missing values render as an em
// dash so empty cells stay aligned.

const numberFormat = new Intl.NumberFormat();
const compactFormat = new Intl.NumberFormat(undefined, {
  notation: 'compact',
  maximumFractionDigits: 1,
});
const moneyFormat = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'USD',
});
const compactMoneyFormat = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
});

const missing = (value) => value === null || value === undefined;

export const formatNumber = (value) => (missing(value) ? '—' : numberFormat.format(value));
export const formatCompact = (value) => (missing(value) ? '—' : compactFormat.format(value));
export const formatMoney = (value) => (missing(value) ? '—' : moneyFormat.format(value));
export const formatCompactMoney = (value) =>
  missing(value) ? '—' : compactMoneyFormat.format(value);
export const formatPercent = (value) => (missing(value) ? '—' : `${value}%`);
export const formatShare = (share) => `${Math.round(share * 100)}%`;

export function formatDuration(totalSeconds) {
  if (missing(totalSeconds)) return '—';
  const seconds = Math.round(totalSeconds);
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
}

export function formatDate(isoDate, options = { month: 'short', day: 'numeric', year: 'numeric' }) {
  if (!isoDate) return '';
  return new Date(`${isoDate.slice(0, 10)}T00:00:00Z`).toLocaleDateString(undefined, {
    timeZone: 'UTC',
    ...options,
  });
}

export function formatDateTime(value) {
  if (!value) return 'Never';
  return new Date(value).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

// RPM bands in USD, shown as a tag on each channel.
export function rpmTier(rpm) {
  if (missing(rpm)) return null;
  if (rpm >= 20) return { label: 'Premium RPM', color: 'success' };
  if (rpm >= 10) return { label: 'High RPM', color: 'primary' };
  if (rpm >= 5) return { label: 'Average RPM', color: 'default' };
  return { label: 'Low RPM', color: 'warning' };
}
